import { Box, Button, Text, Icon } from '@chakra-ui/react'
import Link, { LinkProps } from 'next/link'
import { X } from 'react-feather'
import { MouseEventHandler } from 'react'

import { Body, Heading } from 'atoms/typography'

interface OverlayModalProps {
  heading: React.ReactNode
  content: React.ReactNode
  ctaHref?: LinkProps['href']
  ctaText?: string
  ctaOnClick?: MouseEventHandler
  secondaryCtaHref?: LinkProps['href']
  secondaryCtaText?: string
  secondaryCtaOnClick?: MouseEventHandler
  onClose?: () => void
}

const OverlayModal: React.FC<OverlayModalProps> = ({
  heading,
  content,
  ctaHref,
  ctaText,
  ctaOnClick,
  secondaryCtaHref,
  secondaryCtaText,
  secondaryCtaOnClick,
  onClose,
}) => {
  const showCta = ctaText != null && ctaHref != null
  const showSecondaryCta = secondaryCtaText != null && secondaryCtaHref != null

  return (
    <Box
      display="flex"
      position="relative"
      flexDirection="column"
      justifyContent="space-between"
      w="98"
      bgColor="white"
      boxShadow="base"
      p="10"
    >
      {onClose ? (
        <Button
          variant="ghost"
          color="charcoal"
          w="3rem"
          position="absolute"
          right="0"
          top="3"
          onClick={onClose}
        >
          <Icon as={X} boxSize="6" />
        </Button>
      ) : null}

      <Heading size="lg">
        <Text fontWeight="semibold">{heading}</Text>
      </Heading>

      <Body my="2">{content}</Body>

      <Box textAlign="center">
        {showCta ? (
          <Link href={ctaHref} passHref>
            <Button as="a" onClick={ctaOnClick} my="4">
              {ctaText}
            </Button>
          </Link>
        ) : null}

        {showSecondaryCta ? (
          <Link href={secondaryCtaHref} passHref>
            <Button as="a" onClick={secondaryCtaOnClick} variant="link">
              {secondaryCtaText}
            </Button>
          </Link>
        ) : null}
      </Box>
    </Box>
  )
}

export default OverlayModal
